import styled from 'styled-components';

export const LocationsWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export const BlueText = styled.span`
  color: #506BCA;
`